<template lang="pug">
  #all-establishments-search
    .search-bar
      input(
        type="text" ref="searchBar"
        placeholder="Nom établissement / Nom fiche / ID fiche"
        @input="searchInputHandler"
      )
      i.material-icons search
    establishment-list(
      :establishments="foundEstablishments"
      :actions="listActions"
      :loading="loading"
      @scrollEnd="nextPage"
      @add="addEstablishment"
      @hover="establishmentHoverHandler"
      @goToEstablishment="goToEstablishment"
    )
      template(v-if="!searchValue.length" v-slot:noResults="") Utilisez la barre de recherche pour choisir d'autres établissements.
      template(v-else v-slot:noResults="") Aucun résultat ne correspond à votre recherche.
    add-establishments-modal(
      ref="addEstablishmentsModal"
      :establishment="establishment"
      @merge="$emit('update')"
    )
</template>

<script>
import rcDebounce from '@/mixins/rcDebounce.js';
import establishmentService from '@/services/establishments.js';
import EstablishmentList from '@/components/establishment-list/EstablishmentList.vue';
import AddEstablishmentsModal from './AddEstablishmentsModal.vue';
import { rcLoader } from '@/directives/rc-loader/rcLoader.js';

export default {
  mixins: [rcDebounce],
  directives: { rcLoader },
  components: {
    EstablishmentList,
    AddEstablishmentsModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      foundEstablishments: [],
      listActions: [{ label: "Ajouter à l'établissement", event: 'add' }],
      SEARCH_DEBOUNCE: 1000,
      loading: false,
      searchValue: '',
      page: 0,
      count: 0,
    };
  },
  methods: {
    nextPage() {
      if (this.foundEstablishments.length < this.count) {
        this.page++;
        this.search(this.searchValue);
      }
    },
    async search(search) {
      this.searchValue = search;
      if (search && search.length) {
        this.loading = true;
        const response = await establishmentService.get({ search, page: this.page, excludeId: this.establishment.id });
        this.foundEstablishments = this.page ? [...this.foundEstablishments, ...response.elements] : response.elements;
        if (this.page === 0) {
          this.count = response.stats.total;
        }
        this.loading = false;
      } else {
        this.foundEstablishments = [];
      }
      if (!search) {
        this.$refs.searchBar.value = '';
      }
    },
    searchInputHandler(e) {
      this.rcDebounce(() => { this.page = 0; this.search(e.target.value) }, this.SEARCH_DEBOUNCE);
    },
    addEstablishment({ establishmentId }) {
      const establishment = this.foundEstablishments.find(it => establishmentId === it.id);
      this.$refs.addEstablishmentsModal.establishments = [establishment];
    },
    establishmentHoverHandler({ establishmentId }) {
      if (establishmentId) {
        const establishment = this.foundEstablishments.find(it => establishmentId === it.id);
        this.$emit('hover', { establishment });
      } else {
        this.$emit('hover', { establishment: null });
      }
    },
    goToEstablishment({ establishmentId }) {
      this.$router.push(`/establishment/${establishmentId}`);
    },
  },
}
</script>

<style lang="scss">
  #all-establishments-search {
    .search-bar {
      border-bottom: 1px solid #BABABA;
      width: 320px;
      display: flex;
      color: #BABABA;
      margin-bottom: 1em;
      input {
        &::placeholder {
          color: #BABABA;
        }
        outline: none;
        font-size: 16px;
        border: none;
        width: 100%;
      }
    }
    .establishment-list {
      &.empty,.load-content {
        min-height: 20em;
      }
    }
  }
</style>